import { pipe } from 'fp-ts/lib/function';
import { parse, struct, success } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { ApplicationId } from '../../../../organization/ApplicationId';

export const Params = struct({
	applicationId: ApplicationId,
	ref: pipe(
		iotsUtils.NotEmptyString,
		parse((r) => success(decodeURIComponent(r)))
	),
});
